module.exports = __webpack_public_path__ + "static/img/chanping21.5aeb8c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/srzq/chanping21.jpg
// module id = pRgA
// module chunks = 0